import { createFileRoute, redirect } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

// `/monitoring/agent` and `/monitoring/agent/:sessionId`, the URLs of the monitoring agent that the Insights agent
// replaced. Its sessions were not carried over, so a session id names no conversation, and every old link opens a
// draft. The splat takes the bare `/monitoring/agent` as well.
export const Route = createFileRoute('/_authenticated/monitoring/agent/$')({
    // Only redirects: the target checks its own access.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    beforeLoad: () => {
        throw redirect({
            to: '/monitoring/insights-agent/{-$conversationId}',
            params: { conversationId: undefined },
            replace: true,
        });
    },
});
